import React, { useEffect } from "react";
import { Link } from "react-router-dom";

// Truthful removal page for known spam URL patterns and the i+channel+from
// query-spam combo. This is NOT an HTTP 410 (the platform serves the SPA
// statically and app code cannot emit a 410 for frontend routes). It emits the
// strongest safe code-level removal signal: robots noindex,nofollow, NO
// canonical (so it can never consolidate to the homepage), and no homepage
// content. Real HTTP 410 requires an ingress/CDN rule (Emergent Support).
export default function SpamGone() {
  useEffect(() => {
    document.title = "Page removed | Time Furniture";
    // robots: noindex, nofollow — Google must be able to crawl to see this,
    // so we intentionally do NOT Disallow these URLs in robots.txt.
    let robots = document.head.querySelector('meta[name="robots"]');
    const hadRobots = !!robots; const prevRobots = robots ? robots.getAttribute("content") : null;
    if (!robots) { robots = document.createElement("meta"); robots.setAttribute("name", "robots"); document.head.appendChild(robots); }
    robots.setAttribute("content", "noindex, nofollow");

    // Remove the canonical link entirely so Google gets one unambiguous removal
    // signal (no canonical pointing at the homepage or elsewhere). Also drop
    // og:url. Restored on unmount so normal pages are unaffected.
    const canon = document.head.querySelector('link[rel="canonical"]');
    const canonParent = canon ? canon.parentNode : null;
    const canonNext = canon ? canon.nextSibling : null;
    if (canon) canon.remove();
    const ogUrl = document.head.querySelector('meta[property="og:url"]');
    const ogUrlPrev = ogUrl ? ogUrl.getAttribute("content") : null;
    if (ogUrl) ogUrl.remove();

    return () => {
      if (hadRobots && prevRobots != null) robots.setAttribute("content", prevRobots);
      else if (robots && robots.parentNode) robots.parentNode.removeChild(robots);
      if (canon && canonParent) canonParent.insertBefore(canon, canonNext);
      if (ogUrl && ogUrlPrev != null) { ogUrl.setAttribute("content", ogUrlPrev); document.head.appendChild(ogUrl); }
    };
  }, []);

  return (
    <div data-testid="spam-gone-page" className="bg-[#FAF5EC] min-h-[70vh] flex items-center">
      <div className="max-w-[720px] mx-auto px-6 md:px-12 py-24 text-center">
        <p className="eyebrow mb-5">410 · Gone</p>
        <h1 className="font-serif-display text-4xl sm:text-5xl leading-[1.0] tracking-tight text-[#1C110C]">
          This page has been permanently removed.
        </h1>
        <p className="mt-6 max-w-lg mx-auto text-[#7A6B5F] leading-relaxed">
          The URL you requested is not part of the Time Furniture website and no longer exists.
        </p>
        <Link to="/" data-testid="spam-home-link" className="mt-10 inline-flex items-center gap-3 border border-[#6E1F2C]/40 text-[#6E1F2C] px-9 py-4 text-[11px] tracking-[0.28em] uppercase hover:bg-[#6E1F2C] hover:text-white">
          Go to timefurniture.ae
        </Link>
      </div>
    </div>
  );
}
